<template>
  <div>
    <div style="margin-bottom: 32px; margin-top: -8px">
      <div class="content-input">
        <div class="content-input-item">
          <label>关键词：</label>
          <el-select v-model="blockContent" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in blockContentArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
<!--        <div class="content-input-item">-->
<!--          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />-->
<!--        </div>-->
        <div class="content-input-item">
          <el-button type="primary" @click="getPage(true)"> 查询 </el-button>
        </div>
      </div>
      <div class="content-input" style="display: flex; margin-top: 32px;">
        <div style="display: flex; width: 50%; flex-direction: column;">
          <div style="display: flex">
            <el-image style="width: 90px; height: 90px; margin-right: 16px;" :src="userResume.headImg.smallHeadImg" @click="showImg(userResume.headImg.headImg)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            <div>
              <UserInfoList :row="userResume" showList="name,phone,uid,city" :isDialog="true"/>
              <p @click="openUserList(userResume.userId)" style="cursor: pointer;">聊天人数：<span style="color: #409eff;">{{ chatNum }}</span></p>
            </div>
          </div>
          <ActionButton :row="userResume" direction="horizontal" showList="forbidden,chat,screen,point" style="margin-top: 12px;"/>
<!--          <el-space style="margin-top: 12px;">-->
<!--&lt;!&ndash;            <el-button type="primary" size="small" @click="appointAuth(userResume)">指定认证</el-button>&ndash;&gt;-->
<!--            <AppointAuth :row="userResume" />-->
<!--            <el-button v-if="!userResume.isBannedChat" type="primary" size="small" @click="updateBannedChat(1, userResume, 1)">禁言</el-button>-->
<!--            <el-button v-if="userResume.isBannedChat" type="success" size="small" @click="updateBannedChat(1, userResume, 2)" v-loading="userResume['bannedLoading']">解除禁言</el-button>-->
<!--            <el-button v-if="userResume.screenState == 0 || !userResume.screenState" type="primary" size="small" @click="updateScreenState(1,userResume, 1)" v-loading="userResume['screenLoading']">屏蔽</el-button>-->
<!--            <el-button v-if="userResume.screenState == 1" type="success" size="small" @click="updateScreenState(1, userResume, 0)" v-loading="userResume['screenLoading']">取消屏蔽</el-button>-->
<!--            <el-button v-if="!userResume.isForbidden" type="primary" size="small" @click="updateUserForbidden(1, userResume, 1)" v-loading="userResume['forbiddenLoading']">封号</el-button>-->
<!--            <el-button v-if="userResume.isForbidden" type="success" size="small" @click="updateUserForbidden(1, userResume, 2)" v-loading="userResume['forbiddenLoading']">解除封号</el-button>-->
<!--          </el-space>-->
        </div>
        <div style="display: flex; width: 50%;flex-direction: column;">
          <div style="display: flex">
            <el-image style="width: 90px; height: 90px; margin-right: 16px;" :src="toUserResume.headImg.smallHeadImg" @click="showImg(toUserResume.headImg.headImg)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            <div>
              <UserInfoList :row="toUserResume" showList="name,phone,uid,city" :isDialog="true"/>
              <p @click="openUserList(toUserResume.userId)" style="cursor: pointer;">聊天人数：<span style="color: #409eff;">{{ toChatNum }}</span></p>
            </div>
          </div>
          <ActionButton :row="toUserResume" direction="horizontal" showList="forbidden,chat,screen,point,focus" style="margin-top: 12px;"/>
<!--          <el-space style="margin-top: 12px;">-->
<!--&lt;!&ndash;            <el-button type="primary" size="small" @click="appointAuth(toUserResume)">指定认证</el-button>&ndash;&gt;-->
<!--            <AppointAuth :row="toUserResume" />-->
<!--            <el-button v-if="!toUserResume.isBannedChat" type="primary" size="small" @click="updateBannedChat(2, toUserResume, 1)">禁言</el-button>-->
<!--            <el-button v-if="toUserResume.isBannedChat" type="success" size="small" @click="updateBannedChat(2, toUserResume, 2)" v-loading="toUserResume['bannedLoading']">解除禁言</el-button>-->
<!--            <el-button v-if="toUserResume.screenState == 0 || !toUserResume.screenState" type="primary" size="small" @click="updateScreenState(2, toUserResume, 1)" v-loading="toUserResume['screenLoading']">屏蔽</el-button>-->
<!--            <el-button v-if="toUserResume.screenState == 1" type="success" size="small" @click="updateScreenState(2, toUserResume, 0)" v-loading="toUserResume['screenLoading']">取消屏蔽</el-button>-->
<!--            <el-button v-if="!toUserResume.isForbidden" type="primary" size="small" @click="updateUserForbidden(2, toUserResume, 1)" v-loading="toUserResume['forbiddenLoading']">封号</el-button>-->
<!--            <el-button v-if="toUserResume.isForbidden" type="success" size="small" @click="updateUserForbidden(2, toUserResume, 2)" v-loading="toUserResume['forbiddenLoading']">解除封号</el-button>-->
<!--          </el-space>-->
        </div>
      </div>
    </div>
    <div>
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          style="width: 100%"
          border
          @cell-click="toggleSelection"
          v-loading="listLoading"
      >
        <el-table-column property="chatTime" label="时间"/>
        <el-table-column property="" :label="userResume.nickName">
          <template #default="scope">
            <div v-if="scope.row.userId == userId">
              <div v-if="scope.row.contentType == 1">
                <div v-if="scope.row.violationState == 2">
                  <FixMsg :msg="scope.row.content" :mark="scope.row.fixContent" />
                </div>
                <div v-else>
                  <p :style="[scope.row.sendState != 1 && !scope.row.fixContent?'color:red;':'']">
                    {{ scope.row.content }}
                  </p>
                  <p style="color: #ff0000">{{ scope.row.fixContent }}</p>
                </div>
              </div>
              <div v-if="scope.row.contentType == 2"> <el-image style="width: 80px; height: 80px" :src="scope.row.url" @click="showImg(scope.row.url)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image> </div>
              <div v-if="scope.row.contentType == 3">
                <audio :ref="'audio' + scope.$index" controls :src="scope.row.url" type="audio/mpeg" @play="pauseOther(scope.$index)">您的浏览器不支持该音频格式。</audio>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="" :label="toUserResume.nickName">
          <template #default="scope">
            <div v-if="scope.row.userId == toUserId">
              <div v-if="scope.row.contentType == 1">
                <div v-if="scope.row.violationState == 2">
                  <FixMsg :msg="scope.row.content" :mark="scope.row.fixContent" />
                </div>
                <div v-else>
                  <p :style="[scope.row.sendState != 1 && !scope.row.fixContent?'color:red;':'']">{{ scope.row.content }}</p>
                  <p style="color: red">{{ scope.row.fixContent }}</p>
                </div>
              </div>
              <div v-if="scope.row.contentType == 2"> <el-image style="width: 80px; height: 80px" :src="scope.row.url" @click="showImg(scope.row.url)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image> </div>
              <div v-if="scope.row.contentType == 3">
                <audio :ref="'audio' + scope.$index" controls :src="scope.row.url" type="audio/mpeg" @play="pauseOther(scope.$index)">您的浏览器不支持该音频格式。</audio>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="" label="是否已发送">
          <template #default="scope">
            {{ scope.row.sendState == 1?'已发送':scope.row.sendState == 2?'本平台拦截':scope.row.sendState ==3?'融云拦截':scope.row.sendState ==4?'屏蔽状态拦截':''}}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../../../components/DatePickerRange'
import SearchComponents from '../../../../components/SearchComponents'
import {getUserChatContentPageList, updateScreenState, updateUserBannedChat, updateUserForbidden} from '@/api/url'
import {getFormData, postFormData} from '@/api/api'
import UserLogDialog from '../../../../components/UserLog/UserLogDialog'
import Dialog from '../../../../assets/js/dialog'
import ImgViewer from '../../../../assets/js/imageViewer'
import ChatUserList from "@/views/chat/components/content/ChatUserList";
import BannedChatDialog from "@/components/resume/BannedChatDialog";
import ForbiddenDialog from "@/components/resume/ForbiddenDialog";
// import AppointAuthDialog from "@/components/resume/AppointAuthDialog";
import AppointAuth from "@/components/resume/AppointAuth";
import UserInfoList from "@/components/resume/UserInfoList";
import FixMsg from "@/views/chat/components/content/FixMsg";
import ActionButton from "@/components/resume/ActionButton";

export default {
  name: "InviteDetailDialog",
  components: { DatePickerRange, SearchComponents, AppointAuth, UserInfoList, FixMsg,ActionButton },
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.userId,
      toUserId: this.value.toUserId,
      state: this.value.state,

      blockContentArray: this.value.blockContentArray,
      blockContent: '',

      userResume: this.value.resumeInfo.resumeInfo,
      toUserResume: this.value.resumeInfo.toResumeInfo,
      chatNum: this.value.resumeInfo.chatNum,
      toChatNum: this.value.resumeInfo.toChatNum,


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchType: '',
      searchValue: '',

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //语音
    pauseOther(index) {
      let audioDom= this.$refs['audio'+ index]
      audioDom.play();
      const audios = document.getElementsByTagName('audio');
      [].forEach.call(audios, function (i) {
        if(i !== audioDom) {
          i.pause();
          i.currentTime = 0;
        }
      })
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.userId;
      param['toUserId'] = this.toUserId;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['state'] = this.state;
      param['blockContent'] = this.blockContent;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getUserChatContentPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(url) {
      let imgList = []
      imgList.push(url)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {

    },

    //聊天人数列表
    openUserList(userId) {
      Dialog.open({
        title: '聊天人数列表',
        component: ChatUserList,
        data: {
          id: userId,
          violationState: -1,
          width: '900px'
        },
        close: () => {

        }
      })
    },

    //单个禁言/解除
    updateBannedChat(idx, resume, state) {
      let userIdArr = [];
      userIdArr.push(resume.userId);
      if(state == 1) {
        Dialog.open({
          title: '禁言时间',
          component: BannedChatDialog,
          data: {
            userIdArray: userIdArr,
            width: '500px'
          },
          confirm: () => {
            if ( idx ==1 ) {
              this.userResume['isBannedChat'] = true
            } else if ( idx == 2) {
              this.toUserResume['isBannedChat'] = true
            }
          }
        })
      }else if (state == 2) {
        this.$confirm('确定对用户【'+ resume.nickName + '】解除禁言？')
            .then(() => {
              resume['bannedLoading'] = true
              let param = {}
              param['idArr'] = userIdArr
              param['state'] = 2
              param['day'] = 0
              postFormData(updateUserBannedChat, param).then((data) => {
                let {code, msg} = data;
                if ( code == 200 ) {
                  this.$message({
                    message: msg,
                    duration: 2000,
                    type: 'success'
                  })
                  if ( idx ==1 ) {
                    this.userResume['isBannedChat'] = false
                  } else if ( idx == 2) {
                    this.toUserResume['isBannedChat'] = false
                  }
                } else {
                  this.$message({
                    message: msg,
                    duration: 2000,
                    type: 'warning'
                  })
                }
                resume['bannedLoading'] = false
              }).catch(()=>{
                resume['bannedLoading'] = false
              })
            })
            .catch(() => {
              // catch error
            })
      }
    },

    //更新屏蔽状态
    updateScreenState(idx, resume, state) {
      this.$confirm('确定' + (state==1?'【屏蔽】用户':'【取消屏蔽】用户') +'【' + resume.nickName + '】?').then(()=>{
        resume['screenLoading'] = true
        let param = {}
        param['id'] = resume.userId
        param['screenState'] = state
        postFormData(updateScreenState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            if ( idx ==1 ) {
              this.userResume['screenState'] = state
            } else if ( idx == 2) {
              this.toUserResume['screenState'] = state
            }
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          resume['screenLoading'] = false
        }).catch(()=>{
          resume['screenLoading'] = false
        })
      })
    },

    //更新封号状态
    updateUserForbidden(idx, resume, state) {
      if(state == 1) {
        Dialog.open({
          title: '确定对用户【' + resume.nickName + '】封号？',
          component: ForbiddenDialog,
          data: {
            userId: resume.userId,
            width: '500px'
          },
          confirm: () => {
            if ( idx ==1 ) {
              this.userResume['isForbidden'] = true
            } else if ( idx == 2) {
              this.toUserResume['isForbidden'] = true
            }
          }
        })
      } else if(state == 2) {
        this.$confirm('确定【取消封号】用户' +'【' + resume.nickName + '】?').then(()=>{
          resume['forbiddenLoading'] = true
          let param = {}
          param['id'] = resume.userId
          param['state'] = state
          param['type'] = 99
          param['idfaBanState'] = 0
          postFormData(updateUserForbidden, param).then((data)=>{
            let {code, msg} = data
            if(code == 200) {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              })
              if ( idx ==1 ) {
                this.userResume['isForbidden'] = false
              } else if ( idx == 2) {
                this.toUserResume['isForbidden'] = false
              }
            }else {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
            resume['forbiddenLoading'] = false
          }).catch(()=>{
            resume['forbiddenLoading'] = false
          })
        })
      }
    },

    // 指定认证
    // appointAuth(row) {
    //   Dialog.open({
    //     title: '指定用户【'+ row.nickName +'】去认证？',
    //     component: AppointAuthDialog,
    //     data: {
    //       identity: row.recheckAuthIdentity,
    //       zhima: row.recheckAuthZhima,
    //       video: row.recheckAuthVideo,
    //       identityState: row.identityAuth.identityState,
    //       baiduState: row.identityAuth.baiduState,
    //       zhimaCertifyState: row.identityAuth.zhimaState,
    //       videoState: row.authVideo?row.authVideo.state:'',
    //       cancelVideoAuth: row.cancelVideoAuth,
    //       cancelIdentityAuth: row.cancelIdentityAuth,
    //       cancelZhimaAuth: row.cancelZhimaAuth,
    //       userId: row.userId,
    //       width: '400px'
    //     },
    //     confirm: (result) => {
    //       if(result.type == 1) {
    //         row.cancelIdentityAuth = result.state;
    //       } else if(result.type == 2) {
    //         row.cancelZhimaAuth = result.state;
    //       } else if(result.type == 3) {
    //         row.cancelVideoAuth = result.state;
    //       } else {
    //         row.recheckAuthIdentity = result.recheckAuthIdentity;
    //         row.recheckAuthZhima = result.recheckAuthZhima;
    //         row.recheckAuthVideo = result.recheckAuthVideo;
    //       }
    //     }
    //   })
    // },


  },

  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
